import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const USER_ADDRESSES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            name: 'name',
            address1: 'address1',
            address2: 'address2',
            postalCode: 'postalCode',
            city: 'city',
            optional: 'optional',
            province: 'province',
            country: 'country'
        }),
        [MODE_PROD]: Object.freeze({
            name: 'n',
            address1: 'a1',
            address2: 'a2',
            postalCode: 'pc',
            city: 'c',
            optional: 'o',
            province: 'po',
            country: 'co'
        })
    })
})()
